export const MIXED = 'Mixed';

export default function FlightGroupService() {
    Object.assign(this, {
        getFirstFlight,
        getLastFlight,
        getCabinClass,
        getTouchdownCount,
        getJoinedStopsAndTouchdowns,
        getFlightTouchdownCodes,
    });

    function getFlightTouchdownCodes(group = []) {
        return group.Flights
            .filter((flight) => !!flight.Touchdowns)
            .reduce((acc, value) => [...acc, ...value.Touchdowns], [])
            .map((touchdown) => touchdown.AirportCode);
    }

    function getTouchdownCount(group) {
        return group.Flights.reduce((acc, value) => acc + value.TouchdownCount, 0);
    }

    function getJoinedStopsAndTouchdowns(group = []) {
        const stops = group.FlightStops;
        const touchdowns = group.Flights
            .filter((flight) => !!flight.Touchdowns)
            .reduce((acc, value) => [...acc, ...value.Touchdowns], []);
        return [...stops, ...touchdowns];
    }

    function getFirstFlight(group) {
        return group.Flights[0];
    }

    function getLastFlight(group) {
        return group.Flights[group.Flights.length - 1];
    }

    function getCabinClass(group, recommendation) {
        const cabinClasses = group.Flights.map(({CabinClass}) => CabinClass);
        const uniqueClasses = Array.from(new Set(cabinClasses));
        const [cabinClass] = cabinClasses;
        if (uniqueClasses.length === 1) {
            return cabinClass || recommendation.CabinClass;
        }
        return MIXED;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-group/flight-group-service.js